import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { SALES_ORDER_PAYMENT_CONSTRAINTS } from './payment-constraints.js';
const REVERSAL_REASON_REQUIRED = 'Enter a reason for reversing this payment.';
// History reads the reason to explain a reopen, so a blank one is refused too.
export const reverseSalesOrderPaymentInputSchema = z.object({
    paymentId: requiredUuidString('Payment is required.', 'Invalid payment selection.'),
    reason: z
        .string({ error: REVERSAL_REASON_REQUIRED })
        .trim()
        .min(1, REVERSAL_REASON_REQUIRED)
        .max(SALES_ORDER_PAYMENT_CONSTRAINTS.reversalReason.max),
});
//# sourceMappingURL=reverse-payment-input.js.map